import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ContentData, ContentImageUploadResponse, ContentPageableResponse, ContentUpsertDefaultStatus } from '@app-model/content';
import { FilterOptions } from '@app-model/filter';
import { environment } from '@env/environment';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { delay, map, take } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class ContentsService {
	constructor(private http: HttpClient) {}

	paginate(filter: FilterOptions): Observable<ContentPageableResponse> {
		return this.http.post(`${environment.api}/adminTips/listAll`, filter)
			.pipe(
				map((response: ContentPageableResponse) => response)
			);
	}

	getContent(id: number): Observable<ContentData>;
	getContent(id: string): Observable<ContentData>;
	getContent(id: number|string): Observable<ContentData> {
		return this.http.get(`${environment.api}/adminTips/getById/${id}`)
			.pipe(
				map((response: ContentData) => response),
				take(1)
			);
	}

	uploadContentImage(postId: string, image: File): Observable<ContentImageUploadResponse> {
		const formData = new FormData();
		formData.append('file', image);
		
		return this.http.post(`${environment.api}/adminTips/${postId}/uploadTipImage`, formData)
			.pipe(
				map((response: ContentImageUploadResponse) => response)
			);
	}

	uploadContentFile(postId: string, file: File): Observable<ContentImageUploadResponse> {
		const formData = new FormData();
		formData.append('file', file);
		
		return this.http.post(`${environment.api}/adminTips/${postId}/upload-content`, formData)
			.pipe(
				map((response: ContentImageUploadResponse) => response)
			);
	}

	saveTip(tip: ContentData): Observable<ContentUpsertDefaultStatus> {
		return this.http.post(`${environment.api}/adminTips/upsertTip`, tip)
    		.pipe(
				map((response: ContentUpsertDefaultStatus) => response)
			);
	}

	removeTip(tip: ContentData): Observable<ContentPageableResponse> {
		return this.http.post(`${environment.api}/adminTips/removeTip`, tip)
    		.pipe(
				map((response: ContentPageableResponse) => response)
			);
	}
}
